import { Form, Success } from './components';

const ReplenishPortfolioFlow = {
  Form,
  Success,
};

export { ReplenishPortfolioFlow };
